import { render, staticRenderFns } from "./MembershipCard.vue?vue&type=template&id=23c7ef2b"
import script from "./MembershipCard.vue?vue&type=script&lang=js"
export * from "./MembershipCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports